import React from 'react';
import Publications from '../components/Publications';

const PublicationsPage: React.FC = () => {
  return (
    <div className="pt-16">
      <Publications />
    </div>
  );
};

export default PublicationsPage;
